import type { SortState } from '../../domain/query/sort';

export interface OrderBy {
    field: string;
    direction: 'ASC' | 'DESC';
}

export function buildOrderBy(sort: SortState | null): OrderBy | undefined {
    if (!sort) return undefined;
    return { field: sort.key, direction: sort.dir === 'asc' ? 'ASC' : 'DESC' };
}
